import { useContext } from 'react';
import { CustomizationsContext, CustomizationKey } from '../contexts/CustomizationsContext';
import { useAppSelector } from '../app/hooks';
import { selectLanguage } from '../app/slices/configuration.slice';

const useCustomization = (key: CustomizationKey) => {
	const context = useContext(CustomizationsContext);
	if (!context) {
		throw new Error('useCustomization hook must be used within a CustomizationsProvider');
	}

	const { customizations, getCustomization } = context;

	if (!customizations) {
		return undefined;
	}

	const language = useAppSelector(selectLanguage);

	return getCustomization(key, language);
};

export default useCustomization;
